import { Route } from '@angular/router';

import { MonitoringComponent } from './components/monitoring/monitoring.component';

export const MONITORING_ROUTES: Route[] = [
  {
    path: '',
    component: MonitoringComponent,
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '',
  },
];
